// Components
const LitterListCardComponent = () =>
	import(/*webpackChunkName: "litter-list-card-component" */ "@/app/views/main-view/breeding-management/puppy-management/containers/litter-list-container/components/litter-list-card-component/litter-list-card-component.vue")
const MatingDamSireDetails = () =>
	import(/*webpackChunkName: "mating-dam-sire-details-container" */ "@/app/views/main-view/breeding-management/puppy-management/containers/litter-list-container/components/mating-dam-sire-details-container/mating-dam-sire-details-container.vue")
// Services
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";
// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';

// Third Party libraries
import DatePicker from "vue2-datepicker";

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";

export default {
    name: "LitterListContainer",
    components: { DatePicker, LitterListCardComponent, MatingDamSireDetails },
    mixins: [toastMessageMixins],
    data() {
        return {
            isAPILoading: false,
            isAPISubmitLoading: false,
            matingId: null,

            matingDetails: null,
            matingName: "",
            damDetails: null,
            sireDetails: null,
            littersCount: 0,

            prevRoute: "Mating List",
            prevRouteTo: "",
            maxLittersCount: 15,
            typeOfBirth: null
        };
    },
    async created() {
        if (this.$route.query) {
            await this.getDamAndSireMatingDetails(this.$route.query.id);

            this.matingId = this.$route.query.id;
    
            if(this.$route.query.from === "mating-details"){
                this.prevRoute = "Mating Details";
                this.prevRouteTo = `${BREEDER_ROUTES.EDIT_MATING}?mating=${this.matingId}`
            } else if (this.$route.query.from === "mating-list") {
                this.prevRoute = "Mating List";
                this.prevRouteTo = BREEDER_ROUTES.MATING_LIST;
            } else if(this.$route.query.from === "add-litter" && this.littersCount < this.maxLittersCount){
                this.prevRoute = "Add Litter";
                this.prevRouteTo = `${BREEDER_ROUTES.ADD_LITTER}?id=${this.matingId}&from=litter-management`
            } else if(this.$route.query.from === "dam-details"){
                const damId = this.$route.query.damId;
                this.prevRoute = "Dam Details";
                this.prevRouteTo = `${BREEDER_ROUTES.EDIT_DAM_SIRE}?id=${damId}&from=litter-management`
            } else {
                 this.prevRouteTo = BREEDER_ROUTES.MATING_LIST;
            }
        }
    },
    methods: {
        async getDamAndSireMatingDetails(matingId) {
            if (!matingId) {
                return;
            }

            try {
                this.isAPILoading = true;
                const matingDetailsResponse =
                    await breedingManagementService.getDamAndSireMatingDetails(
                        "mating",
                        matingId
                    );

                if (matingDetailsResponse.status === STATUS_CODES.SUCCESS) {
                    const { data: matingDetails } = matingDetailsResponse;
                    
                    this.damDetails = matingDetails.damDetails;
                    this.sireDetails = matingDetails.sireDetails;
                    this.matingName = matingDetails.alias;
                    this.matingDetails = matingDetails;
                    this.littersCount = matingDetails.littersCount;
                    if (matingDetails.damDetails && matingDetails.damDetails.whelpingDates &&  matingDetails.damDetails.whelpingDates.length > 0) {
                        const lastRecord = matingDetails.damDetails.whelpingDates[matingDetails.damDetails.whelpingDates.length - 1];
                        if (lastRecord.typeOfBirth && 
                            lastRecord.matingId === matingDetails.id
                        ) {
                            this.typeOfBirth = lastRecord.typeOfBirth
                        }
                    }
                } else {
                    const { ERROR_GET_MATING_DETAILS } =
                        this.toastMessages.mating();
                    this.showAPIErrorToast(
                        ERROR_GET_MATING_DETAILS,
                        matingDetailsResponse
                    );
                }
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                this.isAPILoading = false;
            }
        },
        
    }
};
